import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import ModalTablaProductos from "./modalTablaProductos";
import { Mensaje } from "../mensajes2";

export default function ModalImprimirProductoProveedor(props) {
  const op = require("../../../src/modulos/datos");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const [showModal, setShowModal] = useState(false);
  const anioActual = new Date().getFullYear();
  const fechaHoy = new Date().toISOString().split("T")[0];
  const [body, setBody] = useState({
    idProducto: "",
    nomProducto: "",
    desde: `${anioActual}-01-01`,
    hasta: fechaHoy,
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const imprimirReporte = () => {
    try {
      if (!body.idProducto) {
        setMensaje({
          mostrar: true,
          titulo: "ERROR",
          texto: "No se ha Seleccionado Ningún Producto",
          icono: "error",
        });
        return;
      }
      window.open(
        op.reportes +
          "/comprasyalmacen?" +
          "reporte=ProductosProveedorCompras" +
          `&efiscal=${idefiscal}` +
          `&CONDICION=OD.idproducto = ${body.idProducto} and o.fecha between '${body.desde}'::date and '${body.hasta}'::date`,
        "Planilla",
        "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",
      );
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Generar el Reporte",
        icono: "error",
      });
    }
  };

  const aceptarProductos = (item) => {
    setBody((prev) => ({
      ...prev,
      idProducto: item.id,
      nomProducto: item.nombre,
    }));
  };

  const salir = () => {
    props.setShow();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-5 fw-bold text-light m-0">
          Imprimir Productos Proveedores
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between row">
          <div className="col-md-6">
            <div
              className="input-group input-group-sm"
              style={{ width: "100%" }}
            >
              <span className="input-group-text text-uppercase fw-semibold">
                Producto:
              </span>
              <input
                type={"text"}
                name="nomProducto"
                className="form-control text-uppercase text-right"
                value={body.nomProducto}
                disabled
              />
              <button
                type="button"
                className="btn btn-success"
                onClick={() => setShowModal(true)}
              >
                <i className="fas fa-search"></i>
              </button>
            </div>
          </div>
          <div className="col-md-3">
            <div
              className="input-group input-group-sm"
              style={{ width: "100%" }}
            >
              <span className="input-group-text text-uppercase fw-semibold">
                Desde:
              </span>
              <input
                type={"date"}
                name="desde"
                className="form-control text-uppercase text-right"
                value={body.desde}
                onChange={(e) => {
                  const { value } = e.target;
                  setBody((prev) => ({
                    ...prev,
                    desde: value,
                  }));
                }}
              />
            </div>
          </div>
          <div className="col-md-3">
            <div
              className="input-group input-group-sm"
              style={{ width: "100%" }}
            >
              <span className="input-group-text text-uppercase fw-semibold">
                Hasta:
              </span>
              <input
                type={"date"}
                name="hasta"
                className="form-control text-uppercase text-right"
                value={body.hasta}
                onChange={(e) => {
                  const { value } = e.target;
                  setBody((prev) => ({
                    ...prev,
                    hasta: value,
                  }));
                }}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn-sm rounded-pill btn btn-primary col-md-3"
          onClick={() => imprimirReporte()}
        >
          <i className="fas fa-print"></i> Imprimir
        </button>

        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>
      <ModalTablaProductos
        show={showModal}
        onHiden={() => setShowModal(false)}
        aceptarProductos={aceptarProductos}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
    </Modal>
  );
}
